import { render, staticRenderFns } from "./EmployeeSkillsProfile.vue?vue&type=template&id=4857f95c&scoped=true"
import script from "./EmployeeSkillsProfile.vue?vue&type=script&lang=js"
export * from "./EmployeeSkillsProfile.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSkillsProfile.vue?vue&type=style&index=0&id=4857f95c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4857f95c",
  null
  
)

export default component.exports